/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Discount_Rule_UpdatedInputs */

const vi_toast_discount_rule_updated = /** @type {(inputs: Toast_Discount_Rule_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật chiết khấu`)
};

/**

* @param {Toast_Discount_Rule_UpdatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_discount_rule_updated = /** @type {((inputs?: Toast_Discount_Rule_UpdatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Discount_Rule_UpdatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_discount_rule_updated(inputs)
});